export const initialFormValues = {
  economicGroup: '',
  profitCenter: '',
  budget: '',
  actualPreview: '',
  deviationVsBudget: '',
  accounts: [
    {
      account: '',
      returnJustification: '',
      draftIds: {} as Record<string, string>
    }
  ]
}
